/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

import type { DateTaxPeriod } from './DateTaxPeriod';
import type { IntervalTaxPeriod } from './IntervalTaxPeriod';
import type { MoneyAmount } from './MoneyAmount';
import type { MonthTaxPeriod } from './MonthTaxPeriod';
import type { QuarterTaxPeriod } from './QuarterTaxPeriod';
import type { YearTaxPeriod } from './YearTaxPeriod';

/**
 * AT tax position data.
 */
export type AtTaxPosition = {
    /**
     * Type of tax.
     */
    taxType: string;
    /**
     * Tax position period type.
     */
    taxPeriodType: AtTaxPosition.taxPeriodType;
    /**
     * Tax position period value.
     */
    taxPeriodValue: (YearTaxPeriod | MonthTaxPeriod | IntervalTaxPeriod | QuarterTaxPeriod | DateTaxPeriod);
    amount: MoneyAmount;
    /**
     * Flag indicating if tx position amount is positive amount
     */
    toYourCredit: boolean;
};

export namespace AtTaxPosition {

    /**
     * Tax position period type.
     */
    export enum taxPeriodType {
        YEAR = 'YEAR',
        MONTH = 'MONTH',
        INTERVAL = 'INTERVAL',
        QUARTER = 'QUARTER',
        DATE = 'DATE',
    }


}

